import { render, staticRenderFns } from "./dataTitle.vue?vue&type=template&id=5a97be6a&scoped=true"
import script from "./dataTitle.vue?vue&type=script&lang=js"
export * from "./dataTitle.vue?vue&type=script&lang=js"
import style0 from "./dataTitle.vue?vue&type=style&index=0&id=5a97be6a&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5a97be6a",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/jenkins_home/workspace/Test-OA/jh-oa-web/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('5a97be6a')) {
      api.createRecord('5a97be6a', component.options)
    } else {
      api.reload('5a97be6a', component.options)
    }
    module.hot.accept("./dataTitle.vue?vue&type=template&id=5a97be6a&scoped=true", function () {
      api.rerender('5a97be6a', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/pages/assetManagement/common/dataTitle.vue"
export default component.exports